import { createContext } from "react";

const giphyContext = createContext();

export default giphyContext;
